import { Link } from 'react-router-dom';
import AppShell from '../components/AppShell';

export default function NotFoundPage() {
  return (
    <AppShell>
      <div className="max-w-md mx-auto px-4 py-24 text-center">
        <p className="text-6xl font-extrabold text-primary">404</p>
        <h1 className="mt-4 text-2xl font-bold tracking-tight">
          Page not found
        </h1>
        <p className="mt-2 text-slate-400">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center px-5 py-2.5 rounded-full gradient-cta text-white font-semibold text-sm transition-all"
        >
          Back to home
        </Link>
      </div>
    </AppShell>
  );
}
